'use strict';

/**
 * List item for the recent import list
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoItemView = require('base/Colido.ItemView');

var template = require('../../templates/partials/import-recent-list-item.hbs');

var ImportRecentListItem = ColidoItemView.extend({
    template: template,

    wrapItem: false,

    modelEvents: {
        'change sync': 'render',
    },
});

module.exports = ImportRecentListItem;